export enum Routes {
  GET_TOKEN = '/api/initdata',
  GET_ME = '/api/me',
  GET_PUBLIC_PROFILE = '/api/users',
  UPDATE_PROFILE = '/api/me/profile',
  SETTINGS = '/api/me/settings',
  MESSAGE = '/api/messages',
  INBOX = '/api/inbox',
  OUTBOX = '/api/outbox',
  HIDE_MESSAGES = '/api/hide/messages',
  BLOCK_SENDER = '/api/block/sender',
  LIST_BLOCKED_USERS = '/api/blocked/senders',
  UNBLOCK_USER = '/api/unblock/sender',
  GET_HINT = '/api/hints/messages',
  GET_STATS = '/api/me/stats',
  HEALTH = '/health',
  STARS_INVOICE = '/api/payments/stars/invoice',
  TON_CREATE = '/api/payments/ton/create',
  TON_VERIFY = '/api/payments/ton/verify',
  PAYMENT_HISTORY = '/api/payments/history',
  PAYMENT_PRICING = '/api/payments/pricing',
  SEND_FEEDBACK = '/api/feedback',
  COMPLETE_ONBOARDING = '/api/me/onboarding'
}

export enum AppPages {
  HOME = '/home',
  SETTINGS = '/settings',
  SETTINGS_EDIT_PROFILE = '/settings/edit_profile',
  SETTINGS_WALLET = '/settings/wallet',
  SETTINGS_HISTORY = '/settings/history',
  SETTINGS_BLOCKED_LIST = '/settings/blocked_list',
  SETTINGS_ABOUT = '/settings/about',
  SETTINGS_PRIVACY_POLICY = '/settings/privacy_policy',
  SETTINGS_TERM_OF_SERVICE = '/settings/terms_of_use',
  SETTINGS_HELP_AND_FEEDBACK = '/settings/help_and_feedback',
  PROFILE = '/profile',
  SHARE = '/share',
  SEND = '/send',
  INBOX = '/inbox',
  OUTBOX = '/outbox',
  SEARCH = '/search'
}

export enum HttpMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  PATCH = 'PATCH',
  DELETE = 'DELETE'
}

export enum TelegramURL {
  BASE = 'https://t.me',
  SHARE = 'https://t.me/share/url'
}

export const RevealStatusMap = {
  '0': 'ANONYMOUS',
  '1': 'HINT_1',
  '2': 'HINT_2',
  '3': 'HINT_3'
} as const;
export type RevealStatusKey = keyof typeof RevealStatusMap;

export enum MessageSort {
  NEWEST = 'newest',
  OLDEST = 'oldest'
}

export enum MessageFilter {
  ALL = 'all',
  UNREVEALED = 'unrevealed',
  REVEALED = 'revealed'
}

export const MESSAGE_PER_PAGE = 20;
export const MESSAGE_MAX_PAGE = 10;
